import React from "react";
import SVG from "react-inlinesvg";
import arrow from "icons/arrow.svg";

export default () => {
  return <SVG src={arrow} width={60} />;
};
